import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	active: true,
	smallSize: true,
};
export const switchSlice = createSlice({
	name: 'switch',
	initialState,
	reducers: {
		toggleSwitch: (state) => {
			state.active = !state.active;
		},
		toggleSmallSize: (state, active) => {
			state.smallSize = !state.smallSize;
		},
	},
});

export const { toggleSwitch, toggleSmallSize } = switchSlice.actions;
export default switchSlice.reducer;
